export var okagesamaNoMoriUrls = {
    ja: 'https://okagesama.typica.jp',
    en: 'https://okagesama.typica.jp/en/',
    ko: 'https://okagesama.typica.jp/kr/',
    'zh-TW': 'https://okagesama.typica.jp/tw/',
    it: 'https://okagesama.typica.jp/en/',
    es: 'https://okagesama.typica.jp/es/',
    de: 'https://okagesama.typica.jp/en/',
    fr: 'https://okagesama.typica.jp/en/',
};
